/*
 * @Author: yuanjianlong
 * @Description: 精准学eventbus
 * @Date: 2021-09-15 15:45:39
 * @LastEditTime: 2022-03-17 09:52:05
 */
import Vue from 'vue'
export const EventBus = new Vue()